import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from '../../common/hooks/useThunkDispatch';
import { useIsUserCompany, useShoppingUserId } from '../../common/hooks/useUserProfile';
import { storeSelectors } from '../../common/selectors/storeSelectors';
import { useIsB2BRoute } from '../../common/utils/b2bUtils';
import sectionFlow from '../flow/sectionFlow';

const useEcommerceSections = () => {
    const currentProductionUnit = useAppSelector(storeSelectors.currentProductionUnit);
    const isB2BRoute = useIsB2BRoute();
    const shoppingUserId = useShoppingUserId();
    const isCompanyUser = useIsUserCompany();
    const { data } = useQuery({
        queryKey: ['productSections', { currentProductionUnit, isB2BRoute, shoppingUserId }],
        queryFn: () => {
            return sectionFlow.getSectionTree(
                currentProductionUnit,
                isB2BRoute,
                isCompanyUser,
                shoppingUserId,
            );
        },
        enabled: true,
    });

    return { sectionTree: data, hasSections: !!data?.length };
};

export default useEcommerceSections;
